import autoComplete from "@tarekraafat/autocomplete.js";

const autoCompleteJS = new autoComplete({
  selector: "#ke_search_sword",
  placeHolder: "Suche",
  debounce: 300,
  searchEngine:"loose",
  data: {
    src: async (query) => {
      try {
        const response = await fetch(`/?type=123&tx_kesearch_pi1[sword]=${query}`);
        const resultPage = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(resultPage, "text/html");

        const resultList = doc.querySelector('#kesearch_results');
        const anchors = Array.from(resultList.querySelectorAll('.result-title a'));

        const keywords = query.toLowerCase().split(/\s+/); // split by space

        return anchors.filter(anchor => {
          const text = anchor.innerText.toLowerCase();
          return keywords.every(word => text.includes(word));
        });

      } catch (error) {
        console.error("Error fetching search results:", error);
        return [];
      }
    },
  },
  resultsList: {
    noResults: true,
    element: (list, data) => {
      if (!data.results.length) {
        // Create "No Results" message element
        const message = document.createElement("div");
        // Add class to the created element
        message.setAttribute("class", "no_result");
        // Add message text content
        message.innerHTML = `<span>Keine Ergebnisse für "${data.query}" gefunden</span>`;
        // Append message element to the results list
        list.prepend(message);
      }
    },
  },
  resultItem: {
    element: (item, data) => {
      item.innerHTML = `
        <a href="${data.value}">
          ${data.value.innerText}
        </a>`;
    },
    highlight: true,
  }
});


